
import mainblock from './mainblock.js'
import minies from './minies.js'
import media from './media.js'

const state = {
           
    color:'#fff',
    name:'Companies',
    showminies: true,
    showmedia: false,
    vuexnamespace: 'companies',
    initmutation:'companies/COMPANY_INIT_COMPANY',
    backlink:'companies',
    duplicateable:true,
    helptext:"Firmen sind in diesem Programm sowohl die Kunden als auch die Lieferanten.<br> Diese werden mittels\n\
            der Kategorie von einander unterschieden. <br> Pflichfelder hier sind der Name, eine E-Mail und die vorher\n\
            angesprochene Kategorie. Der Namenzusatz, die Internetadresse (Web) als auch die Telefon-, Fax- und Handynr\n\
            sind optional. <br>Im unteren Bereich kann man der Firma eine Adresse zuordnen. Mit dem 'weißen' Plus-Zeichen\n\
            öffnet man ein Dialogfeld zur Eingabe einer neuen Adresse.<br> Gespeichert wird mit dem einfachen Haken.<br>\n\
            Mit dem schwarzen Kreuz wird das Formular ohne zu speichern verlassen.<br><br>\n\
            Der Button mit dem Doppelhaken kann ein Datensatz dupliziert werden. Dieser ist dann gleich geöffnet und\n\
            zur Bearbeitung bereit."
                                                   
    
};

export default {
    namespaced: true,
    modules: {
        mainblock: mainblock,
        minies:minies,
        media:media        
    },
    state,
  
};